export function notifContextMatches(context, email, token) {
  return !!context && context.email === String(email || '').toLowerCase() && context.token === (token || '');
}

export function notifFlagMessages(flags, fallbackTitle = 'IRONLOG') {
  if (!flags || typeof flags !== 'object' || Array.isArray(flags)) return [];
  const out = [];
  const add = (key, name, canonical) => {
    if (flags[key] === true) out.push({ name, text: canonical, type: 'system' });
    else if (typeof flags[key] === 'string' && flags[key]) out.push({ name, text: flags[key], type: 'system' });
  };
  add('streak_reminder', '🔥 Keep Your Streak!', "Don't forget to log today's workout.");
  add('double_xp', '⚡ Double XP Active!', '2× XP on your next workout — make it count!');
  add('comeback', 'Welcome back! 💥', "3× XP on your next workout. Let's go.");
  add('mission_reminder', '🎯 Daily Missions', 'You still have missions to complete today for bonus XP.');
  add('shield_awarded', '🛡️ Streak Shield Earned!', 'A shield has been added to your account.');
  if (typeof flags.custom === 'string' && flags.custom) {
    out.push({ name: typeof flags.custom_title === 'string' && flags.custom_title ? flags.custom_title : fallbackTitle,
      text: flags.custom, type: 'system' });
  }
  return out;
}
